import request from './request'
import { MEMBER_MONTHLY_URL, MEMBER_ACCOUNT_URL, MEMBER_NOVELS_URL, MEMBER_RECHARGE_URL, CANCEL_ACCOUNT_URL, CONTRACT_DOWNLOAD_URL, MEMBER_WORK_LIST_URL } from './config'

/**
 * 获取会员套餐配置（/api/good/monthly）
 * 返回值尽量兼容多种结构：数组、{ list: [] }、{ plans: [] } 等
 */
export async function getMemberMonthly () {
  try {
    const data = await request.get(MEMBER_MONTHLY_URL)
    let list = []
    if (Array.isArray(data)) {
      list = data
    } else if (data && Array.isArray(data.plans)) {
      list = data.plans
    } else if (data && Array.isArray(data.list)) {
      list = data.list
    } else if (data && Array.isArray(data.data)) {
      list = data.data
    }
    return list
  } catch (err) {
    return []
  }
}

/**
 * 获取会员账户信息（/api/member/account）
 * 返回 { memberAccountInfo, memberHisLogList }，失败返回 null
 */
export async function getMemberAccount () {
  try {
    const data = await request.get(MEMBER_ACCOUNT_URL)
    if (!data || !data.memberAccountInfo) return null
    return {
      memberAccountInfo: data.memberAccountInfo,
      novelHisLogList: Array.isArray(data.novelHisLogList) ? data.novelHisLogList : []
    }
  } catch (err) {
    return null
  }
}

/**
 * 获取我的小说列表（/api/member/novels）
 * @param {number} fromIndex 页码（或起始索引，由后端约定）
 * @param {number} pageSize 每页数量
 * 返回 { list, total }，失败返回 { list: [], total: 0 }
 */
export async function getMemberNovels (fromIndex, pageSize) {
  const params = {}
  if (typeof fromIndex === 'number') params.fromIndex = fromIndex
  if (typeof pageSize === 'number') params.pageSize = pageSize

  try {
    const data = await request.post(MEMBER_NOVELS_URL, params)
    let list = []
    let total = 0

    if (Array.isArray(data)) {
      list = data
    } else if (data) {
      if (Array.isArray(data.list)) {
        list = data.list
      } else if (Array.isArray(data.data)) {
        list = data.data
      }
      if (typeof data.total === 'number') {
        total = data.total
      }
    }

    if (total === 0 && Array.isArray(list)) {
      total = list.length
    }

    return { list, total }
  } catch (err) {
    return { list: [], total: 0 }
  }
}

/**
 * 获取单独积分购买选项（/api/member/recharge）
 * 返回数组，每项含 name 等，失败返回 []
 */
export async function getMemberRecharge () {
  try {
    const data = await request.get(MEMBER_RECHARGE_URL)
    let list = []
    if (Array.isArray(data)) {
      list = data
    } else if (data && Array.isArray(data.list)) {
      list = data.list
    } else if (data && Array.isArray(data.data)) {
      list = data.data
    }
    return list
  } catch (err) {
    return []
  }
}

/**
 * 我的资产 - 查看全部列表（/api/member/create）
 * @param {string} type 类型：1短篇 2长篇 3核心梗 4大纲
 * @param {number} page 页码（兼容参数；实际会同时映射到 fromIndex）
 * @param {number} pageSize 每页数量
 */
export async function getMemberWorkList (type, page, pageSize) {
  const params = { type }
  if (typeof page === 'number') {
    // 参照 /api/member/work 的翻页参数：fromIndex/pageSize
    // 同时保留 page 以兼容后端/历史版本
    params.fromIndex = page
    params.page = page
  }
  if (typeof pageSize === 'number') params.pageSize = pageSize

  try {
    const data = await request.post(MEMBER_WORK_LIST_URL, params)
    const list = (data && Array.isArray(data.list)) ? data.list : (Array.isArray(data) ? data : [])
    const total = (data && typeof data.total === 'number') ? data.total : list.length
    return { list, total }
  } catch (err) {
    return { list: [], total: 0 }
  }
}

/**
 * 账户注销（CANCEL_ACCOUNT_URL，URL 待定）
 * @returns {Promise} 成功 resolve，失败 reject
 */
export function cancelAccount () {
  return request.post(CANCEL_ACCOUNT_URL, {})
}

/**
 * 下载/查看合同（POST /api/esign/download）
 * @param {string|number} workId 作品 ID
 * @returns {Promise<{ path: string }>} 成功时返回 { path }，path 为文件下载地址
 */
export async function getContractDownload (workId) {
  const data = await request.post(CONTRACT_DOWNLOAD_URL, { workId })
  const path = (data && data.path) || (data && data.data && data.data.path) || ''
  return { path }
}
